<span class="display-symbol" [innerHTML]="displaySymbol?.symbol || ''"></span> <span class="display-exchange" [innerHTML]="displaySymbol?.exchange || ''"></span>
